import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { connect,useSelector, } from 'react-redux';
import { Link } from "react-router-dom";
import { getHomeLanding } from "../../../actions";
import Item from "../../../item";
import { appConstants } from "../../../helpers/app-constants";
import isEmpty from "../../../isEmpty";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../../../index.css";

function ViewPlanSection(props) {
  const { viewLandingView } = useSelector((state) => {
    return state.Home;
  });

  const dispatch = useDispatch();

  const [section, SetSection] = useState([]);
  const [heading, SetHeading] = useState("");
  const [heading2, SetHeading2] = useState("");
  const [btn, SetBtn] = useState({});

  const [backImage, SetBackImage] = useState("");
  const [slides, SetSlides] = useState([]);

  useEffect(() => {
    dispatch(getHomeLanding(props.itemid));
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(viewLandingView)) {
      const items = viewLandingView.items;
      if (!isEmpty(items)) {
        SetBtn(items[0]);
      }
    }
  }, [viewLandingView]);

  return (
    <section className="section_space view_plan_outer">
      <div className="container custom_container">
        <div className="row">
          <div className="col-md-12">
            <div className="view_plan_inner aos-item" data-aos="zoom-in">
              <a href={btn.url} className="go_btn view_plan_btn">
                <i className="fal fa-long-arrow-right"></i>
                {btn.name_en}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { ViewPlanSection };
